import { RetrevaMinimalComponent } from './retreva-minimal.component';
import { AuthenticatedFooterComponent } from '../authenticated/authenticated-footer/authenticated-footer.component';
import { HomeComponent } from './home/home.component';
import { ButtonComponent } from '../../ui/button/button.component';

export const RETREVA_MINIMAL_DECLARATIONS = [
  RetrevaMinimalComponent,
  AuthenticatedFooterComponent,
  HomeComponent,
];

export const RETREVA_MINIMAL_ENTRY_COMPONENTS = [ButtonComponent];

export const RETREVA_MINIMAL_IMPORTS = [];
